import { render, staticRenderFns } from "./AbuseReports.vue?vue&type=template&id=e928e13e&scoped=true"
import script from "./AbuseReports.vue?vue&type=script&lang=js"
export * from "./AbuseReports.vue?vue&type=script&lang=js"
import style0 from "./AbuseReports.vue?vue&type=style&index=0&id=e928e13e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e928e13e",
  null
  
)

export default component.exports